import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Body2, Label, SelectTrigger } from "@activecollab/components";
import PropTypes from "prop-types";
import { useNotebooks } from "~/repository";
import {
  getLoggedUser,
  hasLoggedUserElevatedPermissions,
  isLoggedUserClientSelector,
} from "~/store/selectors/selector.users.jsx";
import { NotebookSelect } from "./NotebookSelect";

export const NotebookSelectContainer = ({ projectId, selectedId, createdById, onChange, className }) => {
  const { t } = useTranslation();

  const { data: notebooks = [] } = useNotebooks(projectId);
  const isUserClientSelector = useSelector(isLoggedUserClientSelector);
  const hasElevetedPermissions = useSelector(hasLoggedUserElevatedPermissions);
  const loggedUser = useSelector(getLoggedUser);
  const isClientPlus = isUserClientSelector && hasElevetedPermissions;
  const showNotesOption = !isUserClientSelector || (isClientPlus && createdById === loggedUser.get("id"));

  const defaultValue = t("Notes");

  const options = useMemo(() => {
    return notebooks.map((notebook) => ({
      id: notebook.id,
      name: notebook.name,
    }));
  }, [notebooks]);

  const selectedName = useMemo(() => options.find(({ id }) => id === selectedId)?.name, [options, selectedId]);

  return (
    <div className={className}>
      <Label
        size="small"
        className="tw-mb-1 tw-flex"
      >
        {t("Notebook")}
      </Label>
      {showNotesOption ? (
        <NotebookSelect
          projectId={projectId}
          selectedId={selectedId}
          onChange={onChange}
          target={<SelectTrigger className="tw-w-full">{selectedName ? selectedName : defaultValue}</SelectTrigger>}
        />
      ) : (
        <Body2 color="secondary">{selectedName ? selectedName : defaultValue}</Body2>
      )}
    </div>
  );
};

NotebookSelectContainer.propTypes = {
  projectId: PropTypes.number.isRequired,
  selectedId: PropTypes.number,
  createdById: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

NotebookSelectContainer.defaultProps = {
  selectedId: 0,
  createdById: 0,
};
